import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-machineproperty',
  templateUrl: './machineproperty.component.html',
  styleUrls: ['./machineproperty.component.css']
})
export class MachinepropertyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
